import { render, staticRenderFns } from "./position-cluster.vue?vue&type=template&id=3d9857cd&scoped=true";
import script from "./position-cluster.vue?vue&type=script&lang=js";
export * from "./position-cluster.vue?vue&type=script&lang=js";
import style0 from "./position-cluster.vue?vue&type=style&index=0&id=3d9857cd&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "3d9857cd", null);
export default component.exports;